import * as React from 'react';

import { Button, ModalWindow } from '@cian/ui-kit';
import { Tabs } from '@cian/ui-kit/prev';
import { CommuteButtonStatus } from '../../store/commute_popup';

import { RoadsContainer } from '../roads/container';
import { RoadsHeaderContainer } from '../roads/header/container';
import { trackDisabledSubmitClicked, trackRoadsPopupClosed, trackRoadsPopupOpened } from '../roads/tracking';
import { Stations } from '../stations';
import { StationsHeaderContainer } from '../stations/header/container';
import { trackRailwayPopupClosed, trackRailwayPopupOpened } from '../stations/tracking';
import { TCommutePopupProps } from './container';

import * as styles from './index.css';
import { CommutePopupTabs } from '../../interfaces/filters';

interface ICommutePopupState {
  tabHeight?: number;
}

const doesObjectHaveProps = (data?: object) => {
  return !!(data && Object.keys(data).length);
};

export class CommutePopup extends React.Component<TCommutePopupProps, ICommutePopupState> {
  public state = {
    tabHeight: undefined,
  };

  private container: HTMLDivElement | null = null;
  private tabRef = React.createRef<HTMLDivElement>();

  public componentDidMount() {
    const { activeTab, tabLabels, roadData, stationData, changeTab } = this.props;

    const isRoadData = doesObjectHaveProps(roadData);
    const isStationData = doesObjectHaveProps(stationData);

    //Если жд или шоссе пришли пустые, то при открытии модала показываем таб, у которого есть данные,
    const enabledTabLabelKeys = (Object.keys(tabLabels) as CommutePopupTabs[]).filter(key => {
      if (key === CommutePopupTabs.Roads && !isRoadData) {
        return false;
      } else if (key === CommutePopupTabs.Stations && !isStationData) {
        return false;
      }

      return true;
    });

    //Если активный таб activeTab из стора задизеблен, показываем оставшийся нулевой элемент массива табов
    if (enabledTabLabelKeys.length && !enabledTabLabelKeys.includes(activeTab)) {
      changeTab(enabledTabLabelKeys[0]);

      // Отправляем разную аналитику в зависимости от открытого таба
      if (enabledTabLabelKeys[0] === CommutePopupTabs.Roads) {
        trackRoadsPopupOpened();
      } else if (enabledTabLabelKeys[0] === CommutePopupTabs.Stations) {
        trackRailwayPopupOpened();
      }
    }

    this.calcTabHeight();

    if (this.container) {
      this.container.focus();
    }
  }

  public render() {
    const { opened = false, roadsButtonStatus, stationsButtonStatus, onPopupAccept } = this.props;
    const { tabHeight } = this.state;

    const isButtonDisabled =
      roadsButtonStatus !== CommuteButtonStatus.Enabled && stationsButtonStatus !== CommuteButtonStatus.Enabled;

    return (
      <ModalWindow
        fixed
        width={1100}
        open={opened}
        onClose={this.onPopupClose}
        header={
          <div>
            <div className={styles['tabs']}>{this.renderMenu()}</div>
            {this.renderHeader()}
          </div>
        }
        footer={
          <div className={styles['footer']}>
            <div onClick={() => isButtonDisabled && trackDisabledSubmitClicked()}>
              <Button size="XS" disabled={isButtonDisabled} onClick={onPopupAccept}>
                Показать посёлки
              </Button>
            </div>
          </div>
        }
      >
        <div className={styles['container']} ref={ref => (this.container = ref)} tabIndex={0}>
          <div className={styles['tab']} ref={this.tabRef} style={{ height: tabHeight }}>
            {this.renderTab()}
          </div>
        </div>
      </ModalWindow>
    );
  }

  private calcTabHeight = () => {
    this.setState({
      tabHeight: this.container?.offsetHeight,
    });
  };

  private renderMenu = () => {
    const { tabLabels, roadData, stationData, activeTab, changeTab } = this.props;

    const isRoadData = doesObjectHaveProps(roadData);
    const isStationData = doesObjectHaveProps(stationData);

    const tabs = Object.keys(tabLabels).map((key: CommutePopupTabs) => {
      const disabled =
        (key === CommutePopupTabs.Roads && !isRoadData) || (key === CommutePopupTabs.Stations && !isStationData);

      return {
        value: key,
        title: tabLabels[key],
        disabled,
      };
    });

    return <Tabs tabs={tabs} activeTab={activeTab} onChange={changeTab} />;
  };

  private onPopupClose = () => {
    const { closePopup, activeTab } = this.props;
    closePopup();

    if (activeTab === CommutePopupTabs.Roads) {
      trackRoadsPopupClosed();
    } else if (activeTab === CommutePopupTabs.Stations) {
      trackRailwayPopupClosed();
    }
  };

  private renderHeader = () =>
    this.props.activeTab === CommutePopupTabs.Roads ? <RoadsHeaderContainer /> : <StationsHeaderContainer />;

  private renderTab = () => (this.props.activeTab === CommutePopupTabs.Roads ? <RoadsContainer /> : <Stations />);
}
